import { createContext, useContext } from "react";
import { DeviceThing } from "../types/DeviceThing.types";

interface SingleMachineContextType {
    machine: DeviceThing | null;
    isLoading: boolean;
}

const SingleMachineContext = createContext<SingleMachineContextType>({
    machine: null,
    isLoading: true,
});

export const useSingleMachineContext = () => useContext(SingleMachineContext);

export default SingleMachineContext;
